export enum SeatApiEmbed {
    Shape = 'shape',
    Transform = 'transform'
}
